module.exports = __webpack_public_path__ + "static/media/bookappointment.c096deea.png";